// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type BufferCacheQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type BufferCacheQuery = {
  __typename?: "GraphqlQuery";
  getBufferCacheUsage?: {
    __typename?: "BufferCacheUsage";
    id: string;
    sharedBuffers: number;
    stats: Array<{
      __typename?: "BufferCacheStats";
      id: string;
      databaseId: string;
      name: string;
      usage: Array<Array<number | null> | null>;
    }>;
  } | null;
  getSystemDetails: {
    __typename?: "SystemDetails";
    info?: {
      __typename?: "SystemInfo";
      data?: {
        __typename?: "SystemInfoData";
        isAuroraServerless?: boolean | null;
      } | null;
    } | null;
  };
  getServerDetails: {
    __typename?: "Server";
    id: string;
    lastSnapshot?: { __typename?: "Snapshot"; collectorVersion: number } | null;
  };
};

export const BufferCacheDocument = gql`
  query BufferCache($serverId: ID!, $startTs: Int!, $endTs: Int!) {
    getBufferCacheUsage(serverId: $serverId, startTs: $startTs, endTs: $endTs) {
      id
      stats {
        id
        databaseId
        name
        usage
      }
      sharedBuffers
    }
    getSystemDetails(serverId: $serverId) {
      info {
        data {
          isAuroraServerless
        }
      }
    }
    getServerDetails(serverId: $serverId) {
      id
      lastSnapshot {
        collectorVersion
      }
    }
  }
`;

/**
 * __useBufferCacheQuery__
 *
 * To run a query within a React component, call `useBufferCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useBufferCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBufferCacheQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useBufferCacheQuery(
  baseOptions: Apollo.QueryHookOptions<
    BufferCacheQuery,
    BufferCacheQueryVariables
  > &
    (
      | { variables: BufferCacheQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BufferCacheQuery, BufferCacheQueryVariables>(
    BufferCacheDocument,
    options,
  );
}
export function useBufferCacheLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BufferCacheQuery,
    BufferCacheQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BufferCacheQuery, BufferCacheQueryVariables>(
    BufferCacheDocument,
    options,
  );
}
// @ts-ignore
export function useBufferCacheSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BufferCacheQuery,
    BufferCacheQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<BufferCacheQuery, BufferCacheQueryVariables>;
export function useBufferCacheSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BufferCacheQuery,
        BufferCacheQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BufferCacheQuery | undefined,
  BufferCacheQueryVariables
>;
export function useBufferCacheSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BufferCacheQuery,
        BufferCacheQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<BufferCacheQuery, BufferCacheQueryVariables>(
    BufferCacheDocument,
    options,
  );
}
export type BufferCacheQueryHookResult = ReturnType<typeof useBufferCacheQuery>;
export type BufferCacheLazyQueryHookResult = ReturnType<
  typeof useBufferCacheLazyQuery
>;
export type BufferCacheSuspenseQueryHookResult = ReturnType<
  typeof useBufferCacheSuspenseQuery
>;
export type BufferCacheQueryResult = Apollo.QueryResult<
  BufferCacheQuery,
  BufferCacheQueryVariables
>;
